<template>
    <div>
        <div style="display:none"> {{list}} </div>
        <BreadCrumb :data="breadCrumb" /> 
         <div class="headerLeft" style="margin: 1rem;" >
            <router-link class="btn hl-element btn-success" variant="success" tag="a" :to="'/Dealer/ServiceForms/Add'"> 
                Yeni Servis Formu
            </router-link>
            <b-button class="hl-element" v-if="inputs" v-b-modal.filterModal variant="info">{{$t('general.filter')}}</b-button>
        </div>
         <b-modal id="filterModal" :title="$t('general.search')" size="lg" :cancel-title="$t('general.cancel')" :ok-title="$t('general.filter')" @ok="search">
            <b-form-group :label="$t('general.filterMsg')" >
                    <div class="filterInputs" v-for="input in inputs" :key="'filter-'+input.key">
                        <b-form-checkbox class="filterChck" style="" v-model="input.checked">
                            {{input.label}}
                        </b-form-checkbox>
                        <Datetime  class="filterInput" v-if="input.type == 'Date'"  v-model="input.val" :disabled="!input.checked"></Datetime>
                        <b-form-select v-if="input.type == 'Select'" class="filterInput" v-model="input.val" :disabled="!input.checked">
                            <b-form-select-option v-for="item in input.array" :key="item.value" :value="item.value">{{item.text}}</b-form-select-option>
                        </b-form-select>
                        <b-form-input class="filterInput" v-else :placeholder="input.label" v-model="input.val" :disabled="!input.checked"></b-form-input>
                    </div>
            </b-form-group>

        </b-modal> 

        <Map v-if="addressList.length > 0" :addressList="addressList" />
        <Modals :open="modalOpen" :modalEvent="openModal" :modalProps="modalProps" :form="currentForm" :modalName="modalName" :onComplete="complete" />

    </div>
</template>

<script>
    import BreadCrumb from '@/components/BreadCrumb'
    import Table from "@/components/Table"
    import i18n from '@/plugins/i18n';
    import Modals from "./modals/";
    import Map from "@/components/Map";
    import L from 'leaflet'
    import technical from '../../../assets/img/technical.png'
    let breadCrumb = [
        { label: i18n.t('pages.dealer.name'), url: "/Dealer" },
        { label: i18n.t('pages.dealer.serviceForms'), url: '' }

    ]
    let serviceTypes = {
        fault: i18n.t('dealer.servicesForm.fault'),
        setup: i18n.t('dealer.servicesForm.setup'),
    }
     let fields = [ 
         { key: 'appointment', type: 'expiredIn', label: i18n.t('dealer.servicesForm.appointmentDate'), keys:['appointment_date']},
         { key: 'customer', label: i18n.t('dealer.servicesForm.customer'), keys:['customer', 'name']},
         { key: 'company', label: i18n.t('dealer.servicesForm.company'), keys:['company', 'name'] },
         { key: 'status_badge', label: i18n.t('dealer.servicesForm.status'), keys:['status'] },
         { key: 'type', data: serviceTypes , type: 'data', label: i18n.t('dealer.servicesForm.type'), keys:['type'] },
         { key: 'product', label: i18n.t('dealer.servicesForm.product'), keys:['product', 'name'] },
         { key: 'user', label: i18n.t('dealer.servicesForm.user'), keys:['user', 'username'] },
         { key: 'actions', label: i18n.t('dealer.list.actions') }        
    ]; 

    let actions = [
        {key: 'appointment', text: i18n.t('dealer.servicesForm.menus.appointment'), state: 0},
        {key: 'movement', text: 'Hareketler', state: 0},
        {key: 'report', text: 'Rapor Al', state: 0},
    ]

    let filtered = ['appointment',"customer", 'company', 'status_badge', 'type', 'product', 'user', 'actions']; 

     let inputs = [ 
        { key: 'companyName', label: 'Hizmet Veren Firma', type: "String", checked: false, val:""},
        { key: 'customerName', label: 'Hizmet Alan Müşteri', type: "String", checked: false, val:""},
        { key: 'status', label:  'Servis Durumu', type: "Select", checked: false, val:"",  array:[
            { text: "Açık", value: "open" },
            { text: "Kapalı", value: "close" }
        ]},
          { key: 'type', label:  'Servis Tipi', type: "Select", checked: false, val:"",  array:[
            { text: "Teknik Servis", value: "fault" },
            { text: "Yeni Kurulum", value: "setup" }
        ]},
    ]; 

    export default {
        name: 'ServiceForms',
         created: async function(){
            await this.$store.dispatch('appointment_get', this.params)
        },
        computed:{
            loading(){
                return this.$store.getters.getDealerLoading
            },
            list(){
                if(this.$store.getters.serviceFormList.length > 0){
                    this.addressList = []
                    this.$store.getters.serviceFormList.map(sf => {
                        this.addressList.push({
                            address: sf.customer.address+' '+sf.customer.town+' / '+sf.customer.city+' / '+ sf.customer.country,
                            icon:  L.icon({ iconUrl: technical, iconSize: [48, 48] }),
                            content: sf.content,
                            customer: sf.customer
                        })
                    })
                }
                return this.$store.getters.serviceFormList
            },
            pageInfo(){
                return this.$store.getters.getServiceFormPageInfo
            }
        },
          watch:{
            limit(val){
                this.params['limit'] = val
                this.$store.dispatch('appointment_get', this.params)
            },
            offset(val){
                 this.params['offset'] = val
                 this.$store.dispatch('appointment_get', this.params)
            }
        },
        data: function(){
            return{
                breadCrumb, fields, filtered, page: 1, limit: 10, actions, modalOpen: false, inputs,
                modalProps: {}, addressList: [], currentForm:"ServiceForm", modalName: "", params:{
                    limit:10,
                    offset: 0,
                }
            }
        },
        components:{
            BreadCrumb, Table, Modals, Map
        },
        methods:{
            goDetail(data){
                this.$router.push( { path: '/Dealer/ServiceForms/'+data.id })
            },
            search(){
                this.inputs.map((input)=>{
                    input.checked ? this.params[input.key] = input.val : delete this.params[input.key]
                })
                this.$store.dispatch('appointment_get', this.params)
            },
              gSearch(data){
                data.length > 0 ? this.params['search'] = data : delete this.params['search']
                this.$store.dispatch('appointment_get', this.params)

            },
            setLimit:function(limit){
                this.limit = limit
            },
            setPage:function(page){
                if(page > 0){
                    this.page = page
                    this.offset = ((page-1) * this.limit)
                }
            },
            actionEvent: async function(key, data){
                switch(key){
                    case 'appointment':
                        this.$store.dispatch('user_list')
                        this.openModal(true, 'Appointment', {data: data})
                        break;
                    case 'movement': 
                        this.$router.push( { path: '/Dealer/ServiceForms/'+data.id+'/Movements' })
                        break;
                    case 'delete':
                        this.openModal(true, 'delete', data)
                        break;
                    case 'reserve':
                        this.openModal(true, 'reserve', {dealer: data})
                        break;
                    case 'report':
                        this.$store.dispatch('serviceFormMovementList', {id: data.id})
                        this.openModal(true, 'Report', { dealer: data });
                        break;
                }
            },
            openModal: function(state, modal, props){
                this.modalOpen = state
                if(state){
                    this.modalProps = props
                    this.modalName = modal
                }
            },
        }
    }
</script>
<style scoped>
.headerLeft{
    display: flex;
    align-items: center;
}
.hl-element {
    margin-right: .3rem;
}
.filterInputs{
    display: flex;
    flex-direction: row;
    justify-content: space-evenly;
    margin-bottom:1rem
}
.filterChck{
    flex: 1; 
    text-align:left
}
.filterInput{
    flex: 4;
}
</style>


// WEBPACK FOOTER //
// src/pages/General/Dealer/ServiceMaps.vue